<template>
    <div class="nevs-content">
        <NevsCard>
            <NevsTextField style="float: left;" :label="$LANG.Get('labels.filter') + ':'" :width="'300px'" v-model="membershipsData.filters.name"></NevsTextField>
            <NevsCheckbox style="float: left; margin-left: 15px;" :width="'auto'" :reserveHeights="true" v-model="membershipsData.filters.show_inactive" :label="$LANG.Get('labels.showInactiveMemberships')"></NevsCheckbox>
            <span style="float: right;"><NevsButton class="primary" @click="addMembership"><i class="fa-solid fa-plus"></i> {{ $LANG.Get('buttons.addMembership') }}</NevsButton></span>
            <div style="clear: both;"></div>

            <NevsTinyGrid :columns="gridColumns" :records="membershipsData.records" :actions="gridActions"
                          :is-inactive="(membership) => !membership.active" @action="gridAction">
                <template #cell-duration="{ record }">{{ record.duration }} {{ record.duration_type }}</template>
            </NevsTinyGrid>
        </NevsCard>
    </div>
</template>

<script>

import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsCheckbox from "@/components/nevs/NevsCheckbox.vue";
import NevsTinyGrid from "@/components/nevs/NevsTinyGrid.vue";

export default {
    name: "ModuleMemberships",
    components: {NevsTinyGrid, NevsCheckbox, NevsTextField, NevsButton, NevsCard},
    data() {
        return {
            membershipsData: {
                filters: {
                    name: '',
                    show_inactive: false
                },
                records: [],
                filterTimer: null
            }
        }
    },
    computed: {
        gridColumns() {
            return [
                {key: 'name', label: this.$LANG.Get('fields.name')},
                {key: 'duration', label: this.$LANG.Get('fields.duration'), align: 'right'},
                {
                    key: 'price_display',
                    label: this.$LANG.Get('fields.priceWithoutTax').split('%currency%').join(this.$HELPERS.GetDefaultCurrency()),
                    align: 'right'
                }
            ];
        },
        gridActions() {
            return [
                {name: 'edit', icon: 'fa-solid fa-pen', tooltip: this.$LANG.Get('tooltips.edit')}
            ];
        }
    },
    watch: {
        'membershipsData.filters.name': {
            handler() {
                if (this.filterTimer !== null) {
                    clearTimeout(this.filterTimer);
                }
                let vm = this;
                this.filterTimer = setTimeout(function () {
                    vm.reloadMemberships();
                    vm.filterTimerOn = false;
                }, 500);
            },
            deep: true
        },
        'membershipsData.filters.show_inactive': {
            handler() {
                this.reloadMemberships();
            }
        }
    },
    methods: {
        gridAction(name, membership) {
            if (name === 'edit') {
                this.editMembership(membership);
            }
        },
        editMembership(membership) {
            this.$router.push('/memberships/' + membership.id);
        },
        addMembership() {
            this.$router.push('/memberships/0');
        },
        reloadMemberships() {
            let vm = this;
            let request = {
                sort: {
                    field: 'name',
                    descending: false
                },
                filters: this.membershipsData.filters,
                currentPage: 1,
                rowsPerPage: 0
            };
            this.$API.APICall('get', 'memberships', request, (data, success) => {
                if (success) {
                    vm.membershipsData.records = data.records;
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        }
    },
    mounted() {
        this.$store.commit('selectMenu', 'catalog');
        this.$store.commit('selectSubMenu', 'memberships');
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.catalog'),
                link: null
            },
            {
                label: this.$LANG.Get('modules.memberships'),
                link: null
            }
        ]);
        this.reloadMemberships();
    }
}
</script>
